import React, { createContext, useContext } from 'react';
import { UserConfigurableModule } from '../types/User';

export type ModuleDrawerState = { module: UserConfigurableModule; uuid: string } | null;

export interface ModuleDrawerContextProps {
  moduleDrawerState: ModuleDrawerState;
  setModuleDrawerState: React.Dispatch<React.SetStateAction<ModuleDrawerState>>;
}

export const ModuleDrawerContext = createContext<ModuleDrawerContextProps | undefined>(undefined);

export const useModuleDrawerContext = (): ModuleDrawerContextProps => {
  const ctx = useContext(ModuleDrawerContext);
  if (!ctx) {
    throw new Error('useModuleDrawerContext must be used within a ModuleDrawerProvider');
  }
  return ctx;
};
